import type { Vehicle } from '@features/vehiclesearch/types/vinvrmsearch.types';
import type { VehicleDerivative } from '@features/vehiclesearch/types/manualsearch.types';

// A bare `VehicleDerivative` carries no `current_status`; returning undefined
// leaves the form field empty and required rather than fabricating a value.
export const resolveVrm = (
    vehicle: Vehicle | VehicleDerivative | null | undefined,
): string | undefined => {
    if (!vehicle || !('current_status' in vehicle)) {
        return undefined;
    }

    return vehicle.current_status?.vrm ?? vehicle.current_status?.formatted_vrm ?? undefined;
};
